import MenuPrimaryItem from "./MenuPrimaryItem";
import { Script } from "gatsby";
import "./css/menu-block.css";

export default function menuBlock(props) {
  if (props.id === undefined) {
    throw new Error("menuBlock component requires an id prop");
  }

  const offset = `${props.offset ?? 0}px`;
  const id = props.id;

  return (
    <>
      <nav
        id={props.id}
        className={`menu-block menu-block--${id}`}
        style={{ top: offset }}
        aria-expanded={"false"}
      >
        <div class="menu-block__observer"></div>
        <h2 className="menu-block__title">
          <span className="menu-block__label">Explore this Section</span>
          <span className="menu-block__chevron"></span>
        </h2>
        <ul className="menu-block__items">
          {props?.items?.map((item, index) => {
            return <MenuPrimaryItem key={index} {...item} />;
          })}
        </ul>
      </nav>
      <Script>
        {`
          (function () {

            // Check if window and document are available
            if(!window || !document){
              return;
            } 

            // Define menu block elements
            const menuBlock = document.getElementById('${id}');

            // Check if menu block exists
            if (!menuBlock){
              return;
            } 

            const menuBlockTitle = menuBlock.querySelector('.menu-block__title');
            const menuBlockObserver = menuBlock.querySelector('.menu-block__observer');
            const menuPrimaryItemWithChildren = menuBlock.querySelectorAll('.menu-primary-item--has-children');
            const menuSecondaryItemWithChildren = menuBlock.querySelectorAll('.menu-secondary-item--has-children');

            // Check if all the above elements exist before proceeding
            if (!menuBlockTitle 
                || !menuBlockObserver 
                || !menuPrimaryItemWithChildren 
                || !menuSecondaryItemWithChildren ){
                  return;
                } 

            // Handle click outside of the menu block
            document.addEventListener("click", function(evt) {
              if (
                !(
                  evt.target.classList.contains("menu-block--${id}") || evt.target.closest(".menu-block--${id}")
                )
              ) {
                const active = document.querySelector(".menu-block--${id}.menu-block--active");
                const expanded = menuBlock.querySelector('.menu-primary-item--expanded .menu-primary-item__link');
                if (active) {
                  menuBlockTitle.click();
                }
                if (expanded) {
                  expanded.click();
                }
              }
            });

            // Toggle the menu block on mobile  
            menuBlockTitle.addEventListener('click', function(evt) {
              evt.preventDefault();
              menuBlock.classList.toggle("menu-block--active");
              const toggledArialExpanded = menuBlock.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
              menuBlock.setAttribute('aria-expanded', toggledArialExpanded);
            });

            // Toggle primary items with children
            menuPrimaryItemWithChildren.forEach((item) => {
              // Grab the menu item link
              const menuPrimaryItemLink = item.querySelector('.menu-primary-item__link');

              // Apply the click event to the menu item link
              menuPrimaryItemLink.addEventListener('click', function(evt) {
                evt.preventDefault();

                // Get the current menu item
                const menuPrimaryItem = evt.target.closest('.menu-primary-item');
                
                // Get the current aria expanded attribute and toggle it
                const toggledAriaExpanded = menuPrimaryItem.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';

                // Close all other menu items
                menuBlock.querySelectorAll('.menu-primary-item').forEach((item) => {
                  item.classList.remove('menu-primary-item--active');
                  item.setAttribute('aria-expanded', 'false');
                  item.classList.remove('menu-primary-item--expanded');
                  item.classList.add('menu-primary-item--not-expanded');
                });

                // Set the current menu item to active
                menuPrimaryItem.classList.add('menu-primary-item--active');

                // Expanded and not expanded classes for mobile styling
                if (toggledAriaExpanded === 'false') {
                  menuBlock.querySelectorAll('.menu-primary-item').forEach((item) => {
                    item.classList.remove('menu-primary-item--not-expanded')
                    item.classList.remove('menu-primary-item--expanded');
                    item.classList.remove('menu-primary-item--active');
                    menuBlock.querySelector('.menu-primary-item--current-page').classList.add('menu-primary-item--active');
                  });
                } else {
                  menuPrimaryItem.classList.remove('menu-primary-item--not-expanded');
                  menuPrimaryItem.classList.add('menu-primary-item--expanded');
                }

                 // Set the toggled aria-expanded attribute to the current menu item
                menuPrimaryItem.setAttribute('aria-expanded', toggledAriaExpanded);
              });
            });

            // Toggle aria-expanded attribute on secondary item click
            menuSecondaryItemWithChildren.forEach((item) => {
              // Grab the menu item link
              const menuSecondaryItemLink = item.querySelector('.menu-secondary-item__link');

              // Apply the click event to the menu item link
              menuSecondaryItemLink.addEventListener('click', function(evt) {
                evt.preventDefault();

                // Get the current menu item
                const menuSecondaryItem = evt.target.closest('.menu-secondary-item');

                // Get the current aria expanded attribute and toggle it
                const toggledAriaExpanded = menuSecondaryItem.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';

                // Set the toggled aria-expanded attribute to the current menu item
                menuSecondaryItem.setAttribute('aria-expanded', toggledAriaExpanded);
              });
            });
          
            // Add sticky modifier when it's sticky
            const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                if (!entry.isIntersecting) {
                  menuBlock.classList.add('menu-block--sticky');
                } else {
                  menuBlock.classList.remove('menu-block--sticky');
                }
              });
            }, {
              rootMargin: '-${offset} 0px 0px 0px'
            });

            // Observe the menu block
            observer.observe(menuBlockObserver);
          })();
      `}
      </Script>
    </>
  );
}
